var _path, _circle, _text, _text2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChargeback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 112.5",
    enableBackground: "new 0 0 90 90",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.701,35.846l0.008,0.007c3.709,3.72,5.563,8.206,5.563,13.455c0,5.253-1.857,9.736-5.57,13.448  c-3.712,3.713-8.195,5.569-13.447,5.569H32.445c-1.226,0-2.271-0.433-3.139-1.3c-0.866-0.866-1.299-1.911-1.299-3.138  c0-1.225,0.434-2.271,1.299-3.137c0.868-0.866,1.913-1.299,3.139-1.299h19.807c2.802,0,5.194-0.99,7.175-2.97  c1.979-1.98,2.969-4.372,2.969-7.174c-0.002-2.803-0.991-5.198-2.969-7.188l-0.007-0.007c-1.979-1.975-4.369-2.962-7.168-2.962  H35.86l3.72,3.002c0.951,0.773,1.492,1.768,1.624,2.981c0.129,1.215-0.192,2.298-0.964,3.255c-0.771,0.955-1.763,1.499-2.976,1.63  c-1.214,0.13-2.3-0.188-3.26-0.958L20.659,38.291c-0.023-0.021-0.048-0.04-0.072-0.058c-0.025-0.021-0.051-0.043-0.077-0.065  c-0.024-0.018-0.048-0.039-0.072-0.058l-0.206-0.188c-0.505-0.476-0.872-1.025-1.1-1.649c-0.038-0.102-0.071-0.206-0.104-0.311  c-0.03-0.105-0.055-0.209-0.078-0.317c-0.049-0.244-0.08-0.497-0.09-0.756c-0.012-0.281,0.001-0.555,0.04-0.822l0.167-0.73  c0.018-0.056,0.037-0.112,0.058-0.168l0.478-0.925c0.16-0.232,0.345-0.454,0.558-0.667c0.007-0.008,0.016-0.016,0.025-0.026  l0.208-0.194c0.042-0.038,0.086-0.074,0.129-0.11c0.062-0.049,0.125-0.097,0.188-0.142l12.873-10.299  c0.961-0.762,2.047-1.075,3.261-0.938c1.212,0.136,2.202,0.684,2.968,1.643c0.767,0.957,1.082,2.042,0.945,3.254  c-0.135,1.213-0.682,2.205-1.637,2.976l-3.169,2.536h16.303C57.506,30.276,61.989,32.133,65.701,35.846z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    cx: 45.188,
    cy: 45.188,
    r: 38.188
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 105,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "Created by Cristiano Zoucas")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 110,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "from the Noun Project")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeback);
export default __webpack_public_path__ + "static/media/chargeback.399a87ae.svg";
export { ForwardRef as ReactComponent };